import React, { useState, useRef, useEffect } from "react";
import Dashboard from "./Dashboard.tsx"
import Devices from "./Devices.tsx";

const DevicesDashboard = () => {

  const [showDashboard, setShowDashboard] = useState(false);
  const [activeComponent, setActiveComponent] = useState("Push Button");

  const apiGatewayRef = useRef(null);
  const pushButtonRef = useRef(null);
  const envDataRef = useRef(null);
  const doorSensorRef = useRef(null);

  const handleScrollToDevicesComponent = (componentName) => {
    if (showDashboard) {
      setShowDashboard(false);
    }
    setActiveComponent(componentName)
  }

  useEffect(() => {
    if (!showDashboard) {
      const timer = setTimeout(() => {
        switch (activeComponent) {
          case "API Gateway":
            if (apiGatewayRef.current) {
              apiGatewayRef.current.scrollIntoView({ behavior: "smooth" });
            }
            break;
          case "Push Button":
            if (pushButtonRef.current) {
              pushButtonRef.current.scrollIntoView({ behavior: "smooth" });
            }
            break;
          case "Environment Data":
            if (envDataRef.current) {
              envDataRef.current.scrollIntoView({ behavior: "smooth" });
            }
            break;
          case "Door Sensor":
            if (doorSensorRef.current) {
              doorSensorRef.current.scrollIntoView({ behavior: "smooth" });
            }
            break;
          default:
            break;
        }
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [activeComponent, showDashboard])

  return (
    <div className="flex flex-col h-full pb-5">
      <div className="flex flex-col h-full">
        <div className="rounded-lg">
          {showDashboard ?
            <Dashboard onComponentClick={handleScrollToDevicesComponent} />
            : <Devices
              setActiveComponent={setActiveComponent}
              activeComponent={activeComponent}
              apiGatewayRef={apiGatewayRef}
              pushButtonRef={pushButtonRef}
              envDataRef={envDataRef}
              doorSensorRef={doorSensorRef}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default DevicesDashboard;
